import React from 'react';
import { FormControl, FormHelperText, FormLabel } from './base/FormControl/FormControl';
import CalendarInput from './base/Input/Input';
export default function TextField(_a) {
    var name = _a.name, value = _a.value, label = _a.label, origin = _a.origin, onChange = _a.onChange, error = _a.error, helperText = _a.helperText, disabled = _a.disabled, min = _a.min;
    return (React.createElement(FormControl, { error: error },
        origin === 'oncall' && (React.createElement(FormLabel, { htmlFor: name }, label)),
        React.createElement(CalendarInput, { name: name, value: value, onChange: onChange, disabled: disabled, min: min }),
        helperText
            && (React.createElement(FormHelperText, null,
                helperText,
                "\u00A0"))));
}
//# sourceMappingURL=TextField.js.map